<!-- Template for Spinner-animation. Provides Fallback for IE and Edge because of a lack of css-animation support -->
<!-- Fallback Spin -->
@if (needsFallBack) {
	<div [attr.aria-busy]="'true'" [attr.title]="titleKey() | translate" class="spin-container">
		<div class="fallback-spinner" #spin></div>
	</div>
}
@if (!needsFallBack) {
	<div [attr.aria-busy]="'true'" [attr.title]="titleKey() | translate" class="spin-container">
		<div [style.width]="getSize()" [style.height]="getSize()">
			<svg class="svg-spin-content" viewBox="0 0 66 66" xmlns:svg="http://www.w3.org/2000/svg">
				<svg:circle
					class="path"
					[ngStyle]="{ stroke: color() }"
					fill="none"
					[attr.stroke-width]="strokeWidth"
					stroke-linecap="round"
					cx="33"
					cy="33"
					r="30"
				></svg:circle>
			</svg>
		</div>
	</div>
}
